import React from 'react';
import PropTypes from 'prop-types';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { animated } from 'react-spring';
import { useCartStore } from 'stores';
// icons
import { RiShoppingBagFill } from 'react-icons/ri';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import LogoComponent from '../LogoComponent';
import LoupeButtonMobile from './LoupeButtonMobile';

const MenuBurgerMobile = ({
  showSearchBar,
  isSticky,
  secondaryImage,
  counterAnimProps,
  setShowOffCanvas,
  setShowSearchBar }) => {
  const { countItems } = useCartStore();
  const { libraryPath } = useAssignedLibrary();

  return (
    <div id="mobile-bar" className="container-fluid mobile-bar p-0">
      {/* BOTON MOVIL HAMBURGUESA */}
      <Navbar.Toggle
        aria-controls="offcanvasNavbar-mobile"
        className="mobile-menu"
        onClick={() => setShowOffCanvas(true)}
      />

      {/* IMAGEN < 992*/}
      <LogoComponent
        isDesktop={false}
        isSticky={isSticky}
        secondaryImage={secondaryImage} />

      {/* BUSQUEDA < 992 */}
      <LoupeButtonMobile
        isSticky={isSticky}
        showSearchBar={showSearchBar}
        setShowSearchBar={setShowSearchBar} />

      {/* BOTON PRODUCTOS < 992 */}
      <Link
        className="header__button header__button--cart mr-2 d-lg-none"
        to={libraryPath('carrito')}
      >
        <RiShoppingBagFill className="icon-md" />
        {countItems > 0 && (
          <animated.span style={counterAnimProps} className="cart-counter">
            {countItems}
          </animated.span>
        )}
      </Link>
    </div>
  );
};

MenuBurgerMobile.propTypes = {
  showSearchBar: PropTypes.bool,
  isSticky: PropTypes.bool,
  isDesktop: PropTypes.bool,
  secondaryImage: PropTypes.bool,
  setShowOffCanvas: PropTypes.func,
  setShowSearchBar: PropTypes.func,
  counterAnimProps: PropTypes.any
};

export default MenuBurgerMobile;
